import type { SportsHit } from "@/features/search/components/Results/models/sportsHit";
import { useTitles } from "@/hooks/graphql/useTitles";
import { TitleIcon } from "@/features/shell/components/shared/TitleIcon";
import React from "react";
import { Row } from "./Row/Row";
import { ResultsInIndex } from "./ResultsInIndex/ResultsInIndex";
import { Highlight } from "./Highlight/Highlight";
import { useNormalisedHits } from "@/features/search/components/Results/hooks/useNormalisedHits";

export const SportsResults = () => {
  const { items, results } = useNormalisedHits<SportsHit>();
  const titles = useTitles();
  return (
    <ResultsInIndex
      indexName={`Sports`}
      total={results?.nbHits || 0}
      pages={results?.nbPages || 0}
      perPage={results?.hitsPerPage || 0}
    >
      {(items || []).map((item) => {
        const sportHighlight = item.normalisedHighlights?.sport?.[0];
        return (
          <Row
            key={item.objectID}
            eventId={item.objectID}
            icon={<TitleIcon title={titles[item.slug]} />}
            title={
              <Highlight
                text={item.sport}
                matchedWords={sportHighlight?.matchedWords || []}
                html={sportHighlight?.value || ""}
              />
            }
            to={`${
              item.hub === "sports"
                ? "/sports"
                : item.hub === "racing"
                  ? "/racing"
                  : ""
            }/${item.slug}/betting`}
          />
        );
      })}
    </ResultsInIndex>
  );
};
